import AvgOfFacingsByBrand from "./AvgOfFacingsByBrand";
export default AvgOfFacingsByBrand;